import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Brain, ArrowRight, CheckCircle } from "@phosphor-icons/react";
import api from "@/api";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Promo card surfaced on the Programme page (and Info) inviting delegates to
 * take the one-shot research quiz. Hides itself when the quiz isn't ready
 * (no images uploaded yet) or the delegate has already submitted.
 */
export default function QuizCTACard() {
  const { user } = useAuth();
  const [state, setState] = useState({ ready: false, submitted: false, loaded: false });

  useEffect(() => {
    let alive = true;
    async function load() {
      try {
        const { data: cfg } = await api.get("/quiz/config");
        const ready = !!cfg.published;
        let submitted = false;
        if (user) {
          try {
            const { data } = await api.get("/quiz/me");
            submitted = !!data.submitted;
          } catch {}
        }
        if (alive) setState({ ready, submitted, loaded: true });
      } catch {}
    }
    load();
    return () => { alive = false; };
  }, [user]);

  if (!state.loaded || !state.ready) return null;

  return (
    <Link
      to="/quiz"
      data-testid="quiz-cta-card"
      className="block mb-4 rounded-sm border border-[#43C4E3]/30 bg-gradient-to-br from-[#43C4E3] to-[#2a8db0] text-[#FFFFFF] p-4 hover:from-[#4dcbe7] hover:to-[#33a0c8] transition-colors"
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-[#FFFFFF]/15 grid place-items-center flex-shrink-0">
          {state.submitted ? <CheckCircle size={20} weight="duotone" /> : <Brain size={20} weight="duotone" />}
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-mono-time text-[10px] uppercase tracking-widest opacity-90">DFTB Conference Quiz</div>
          <div className="font-display text-base sm:text-lg leading-tight !text-[#FFFFFF]">
            {state.submitted ? "Thanks for taking part" : "10 questions · 5 minutes"}
          </div>
        </div>
        <ArrowRight size={18} className="flex-shrink-0" />
      </div>
    </Link>
  );
}
